import Header from "../components/Header";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";
import Banner from "../components/Home/banner";
import Feature from "../components/Home/features";
import About from "../components/Home/about";
import WhyUs from "../components/Home/whyus";
import Work from "../components/Home/work";
import Mission from "../components/Home/mission";
import MoreAbout from "../components/Home/moreabout";
import ReviewSection from "../components/Home/review";

function Home() {
  return (
    <>
      <Header />
      <Banner/>  
      <Feature/>  
      <About/>
      <WhyUs/>
      <Work/>
      <Mission/>
      <MoreAbout/>
      <ReviewSection/>
      <Footer />
    </>
  );
}

export default Home;